const Template = `<div class="info-window">
<div class='tube-info'>
<table >
  <tr>
  	<td class='label'>{{$t('tubes.tube')}}</td> 
	<td class='label'>{{$t('tubes.modem')}}</td>
  </tr>
  <tr>
    <td class='value'>{{ selected.tubeData.tube_name }}</td>
    <td class='value'>{{ selected.tubeData.serial.substring(0,25) }}{{ selected.tubeData.serial.substring(25,26)? '...': '' }}</td>
  </tr>
  <tr>
	<td class='label'>{{$t('tubes.serialNumber')}}</td>
	<td class='label'>{{$t('tubes.activity')}}</td>
  </tr>
  <tr>
	<td class='value'> {{ selected.tubeData.full_serial  }}</td>
	<td class='value'> {{ selected.tubeData.too_old ? '⏰' : '' }}{{ selected.tubeData.measure_time  }}</td>
  </tr>

<!--  <tr>
	<td class='label'>{{$t('tubes.isol')}}</td>
	<td class='label'>{{$t('tubes.battery')}}</td>
  </tr>
  <tr>
    <td class='value'>{{ selected.tubeData.isol == 0 ? '🚫' : '' }}{{ selected.tubeData.isol }}% / {{ selected.tubeData.isol_value }} {{$t('tubes.kOhm')}}</td>
    <td class='value'>{{ selected.tubeData.battery }}%</td>
  </tr>
  <tr>
	<td class='label'>{{$t('tubes.wire')}}</td>
	<td class='label'>{{$t('tubes.phones')}}</td>
  </tr>
  <tr>
	<td class='value'>{{ selected.tubeData.wire == 0 ? '⚡︎' : '' }} {{ selected.tubeData.wire }}% / {{ selected.tubeData.wire_value }} {{$t('tubes.ohm')}}</td>
	<td class='value'>{{getPhones(selected)}}</td>
  </tr>-->
  <tr>
	<td class='label'>{{$t('tubes.coordinates')}}</td>
	<td class='label' v-if="image">
		<a href="#" v-on:click='openImage'>{{$t('tubes.photo')}}</a>
	</td>
	<td class='label' v-else>
		{{$t('tubes.photo')}}		
	</td>
  </tr>
  <tr>
    <td class='value'>{{ JSON.parse(selected.tubeData.marker).coordinates[0].toFixed(4) }}, {{ JSON.parse(selected.tubeData.marker).coordinates[1].toFixed(4) }}</td>
    <td>
      <input id="fileTag"
	    type="file"
            v-on:change="onFileChange"
            v-show="isAdmin()"
	    ref="fileInput"
	    accept="image/*"
          />
	</td>
  </tr>
</table>
<div class="saveButtonWrapper">
    <span>{{$t('tubes.comment')}}</span>
    <button class="input-dark form-control" v-on:click="updateComment" :disabled='!(selected.tubeData.tube_comment != newComment)' >{{$t('tubes.saveComment')}}</button>
</div>

<textarea class="input-dark form-control" v-model='newComment' :placeholder="$t('tubes.enterComment')"></textarea>
</div>  
<div class='chart'>
  <div class="date-range">
    <button class="input-dark form-control" v-bind:class="{ range_active: periodDays == 365 }" v-on:click="changeRange(365)">{{$t('tubes.year')}}</button>
    <button class="input-dark form-control" v-bind:class="{ range_active: periodDays == 183 }" v-on:click="changeRange(183)">{{$t('tubes.halfYear')}}</button>
    <button class="input-dark form-control" v-bind:class="{ range_active: periodDays == 30 }" v-on:click="changeRange(30)">{{$t('tubes.days30')}}</button>
    <button class="input-dark form-control" v-bind:class="{ range_active: periodDays == 10 }" v-on:click="changeRange(10)">{{$t('tubes.days10')}}</button>
    <button class="input-dark form-control" v-bind:class="{ range_active: periodDays == 2 }" v-on:click="changeRange(2)">{{$t('tubes.days2')}}</button>
    <button class="input-dark form-control" v-bind:class="{ range_active: periodDays == 1 }" v-on:click="changeRange(1)">{{$t('tubes.day1')}}</button>
    
    <input class="input-dark form-control" type="date" v-model="startDate">
    <input class="input-dark form-control" type="date" v-model="endDate">

  </div>

<div id="chartContainer" ></div>

</div>  
</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page1_tubes/info_window/template.js